import { ForwardedRef, forwardRef } from "react";
import { CardI } from "../../../interfaces/CardInterface";
import { AdvantageCard } from "./AdvantagesCardStyles";
import { motion } from "framer-motion";

export const AdvantagesCard = forwardRef(
  ({ title, img, text }: CardI, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <AdvantageCard ref={ref}>
        <div className="card__top">
          <img src={img} alt="AdvantagesCard" />
          <h3>{title}</h3>
        </div>
        <div>
          <p>{text}</p>
        </div>
      </AdvantageCard>
    );
  }
);

export const MAdvantagesCard = motion.create(AdvantagesCard);
